import { useCopilotChat } from "@copilotkit/react-core";
import { Role, TextMessage } from "@copilotkit/runtime-client-gql";
import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useState } from "react";
import {
	ActivityIndicator,
	TextInput,
	type TextInputProps,
} from "react-native-paper";

export const Textarea = ({ label, right, ...rest }: TextInputProps) => {
	const [value, setValue] = useState("");

	const { appendMessage, isLoading } = useCopilotChat();

	const handleMessageSend = (text: string) => {
		if (!text) {
			return;
		}

		const message = new TextMessage({
			role: Role.User,
			content: text,
		});

		appendMessage(message);
		setValue("");
	};

	const handleTextChange = (text: string) => {
		setValue(text);
	};

	const rightIcon = right || (
		<TextInput.Icon
			icon={(props) =>
				isLoading ? (
					<ActivityIndicator {...props} size="small" />
				) : (
					<Icon {...props} name="send" size={24} accessibilityLabel="Send" />
				)
			}
			forceTextInputFocus
			onPress={() => handleMessageSend(value)}
			disabled={isLoading}
		/>
	);

	return (
		<TextInput
			autoFocus
			focusable
			mode="outlined"
			blurOnSubmit={false}
			label={label || "Type a message..."}
			style={{ marginHorizontal: 8 }}
			right={rightIcon}
			value={value}
			accessibilityLabel={"Type a message..."}
			onChangeText={handleTextChange}
			onKeyPress={(e) => {
				if (e.nativeEvent.key === "Enter" && !isLoading) {
					handleMessageSend(value);
				}
			}}
			{...rest}
		/>
	);
};
